module.exports = __webpack_public_path__ + "static/media/btn_arrow.6c138afd.svg";